import type { IconData } from '@stacksjs/iconify-core'

export const arrowsV: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5 16.573V3.419L2.464 5.954A1 1 0 0 1 1.05 4.54L5.293.297a1 1 0 0 1 1.414 0L10.95 4.54a1 1 0 1 1-1.414 1.414L7 3.42v13.154l2.536-2.536a1 1 0 1 1 1.414 1.414l-4.243 4.243a.997.997 0 0 1-1.414 0L1.05 15.451a1 1 0 1 1 1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowsV
